import React, { useState } from 'react';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import { desasignarTarjeta } from '../../services/cardService';
import '../../styles/tarjetas.css';

export default function ModalEliminarTarjeta({ open, usuario, token, onRemoveCard, onCancel }) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const nombreCompleto = usuario ? `${usuario.nombre} ${usuario.apellido}` : '';

    const handleConfirm = async () => {
        setLoading(true);
        setError('');
        try {
            await desasignarTarjeta(usuario.id, token);
            onRemoveCard(usuario.id);
        } catch {
            setError('No se pudo eliminar la tarjeta. Intente de nuevo.');
            setLoading(false);
        }
    };

    return (
        <Modal open={open} onClose={loading ? undefined : onCancel}>
            <div className="usuarios-modal">
                <div className="usuarios-modal-header">
                    <p className="usuarios-modal-title">Eliminar tarjeta asignada</p>
                </div>
                <div className="usuarios-modal-body usuarios-modal-body--confirm">
                    <p>
                        ¿Estás seguro de que deseas eliminar la tarjeta asignada a{' '}
                        <strong>{nombreCompleto}</strong>?
                    </p>
                    {error && <p className="tarjetas-modal-error">{error}</p>}
                </div>
                <div className="usuarios-modal-footer">
                    <Button
                        onClick={onCancel}
                        disabled={loading}
                        className="usuarios-modal-cancel"
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={handleConfirm}
                        disabled={loading}
                        className="usuarios-modal-delete tarjetas-btn--danger-text"
                    >
                        {loading ? 'Eliminando...' : 'Eliminar'}
                    </Button>
                </div>
            </div>
        </Modal>
    );
}
